var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classnames from 'classnames';
import CloseButton from '../close-button/CloseButton';
import { GridCollapse, GridWrapper } from '../grid/Grid';
export class Modal extends React.Component {
    componentDidMount() {
        this.disableScrollBlock();
        const onResize = () => {
            if (window.matchMedia('(max-width: 767px)').matches) {
                if (!this.scrollBlockActive) {
                    this.activateScrollBlock();
                }
            }
            else if (this.scrollBlockActive) {
                this.disableScrollBlock();
            }
        };
        const onKeyUp = (e) => {
            if (e.code == 'Escape') {
                const { onCloseClick } = this.props;
                if (onCloseClick) {
                    onCloseClick();
                }
            }
        };
        this.keyListener = onKeyUp.bind(this);
        window.addEventListener('keyup', this.keyListener);
        this.resizeListener = onResize.bind(this);
        window.addEventListener('resize', this.resizeListener);
        onResize();
    }
    disableScrollBlock() {
        this.scrollBlockActive = false;
        window.removeEventListener('wheel', this.scrollListener);
        window.removeEventListener('touchstart', this.touchStartListener);
        window.removeEventListener('touchmove', this.touchMoveListener);
        if (document.body.scrollTo) {
            document.body.scrollTo(0, 0);
        } // Fails in IE/Edge
    }
    activateScrollBlock() {
        if (!this.dom) {
            return;
        }
        const scrollContainer = this.dom;
        this.scrollBlockActive = true;
        const onScroll = (e) => {
            scrollContainer.focus();
            if (scrollContainer === e.target || scrollContainer.contains(e.target)) {
                const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
                if (scrollTop + clientHeight === scrollHeight && e.deltaY > 0) {
                    e.preventDefault();
                }
                else if (scrollTop === 0 && e.deltaY < 0) {
                    e.preventDefault();
                }
            }
            else {
                e.preventDefault();
            }
        };
        let lastY = 0;
        const onTouchStart = (e) => {
            if (e.cancelable) {
                e.preventDefault();
            }
            lastY = e.changedTouches[0].clientY;
        };
        const onTouchMove = (e) => {
            if (scrollContainer === e.target || scrollContainer.contains(e.target)) {
                const deltaY = lastY - e.changedTouches[0].clientY;
                const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
                if (scrollTop + clientHeight === scrollHeight && deltaY > 0) {
                    if (e.cancelable) {
                        e.preventDefault();
                    }
                }
                else if (scrollTop === 0 && deltaY < 0) {
                    if (e.cancelable) {
                        e.preventDefault();
                    }
                }
            }
            else {
                if (e.cancelable) {
                    e.preventDefault();
                }
            }
        };
        this.scrollListener = onScroll.bind(this);
        window.addEventListener('wheel', this.scrollListener);
        this.touchStartListener = onTouchStart.bind(this);
        window.addEventListener('touchstart', this.touchStartListener);
        this.touchMoveListener = onTouchMove.bind(this);
        window.addEventListener('touchmove', this.touchMoveListener, {
            passive: false
        });
    }
    componentWillUnmount() {
        this.disableScrollBlock();
        window.removeEventListener('resize', this.resizeListener);
        window.removeEventListener('keyup', this.keyListener);
    }
    render() {
        const _a = this.props, { className, children } = _a, rest = __rest(_a, ["className", "children"]);
        const onOutsideClick = (event) => {
            if (event.target === event.currentTarget) {
                event.preventDefault();
                if (rest.onCloseClick) {
                    rest.onCloseClick();
                }
            }
        };
        return (React.createElement("div", { className: classnames('Modal', className), ref: ref => (this.dom = ref), role: 'dialog', "aria-modal": 'true' },
            React.createElement(GridWrapper, { className: "Modal__GridWrapper", onClick: onOutsideClick },
                React.createElement(ModalContent, Object.assign({}, rest), children))));
    }
}
export const ModalContent = props => {
    const { className, children, onCloseClick, large, xl } = props;
    return (React.createElement("div", { className: classnames('ModalContent', { 'ModalContent--large': large }, { 'ModalContent--xl': xl }, className) },
        React.createElement(GridCollapse, null,
            React.createElement(CloseButton, { small: true, onClick: () => {
                    if (onCloseClick) {
                        onCloseClick();
                    }
                }, className: "ModalContent__CloseButton" }),
            children)));
};
